<template>
    <md-table-cell class="text-center">
        <span v-if="this.value === this.controlObject.success.value" class="md-tag md-tag-success">{{this.controlObject.success.label}}</span>
        <span v-else-if="this.value === this.controlObject.danger.value" class="md-tag md-tag-danger">{{this.controlObject.danger.label}}</span>
        <span v-else class="md-tag md-tag-info">{{this.controlObject.info.label}}</span>
    </md-table-cell>
</template>

<script>
    import ActiveIndexTypeEnum from "@/enums/ActiveIndexTypeEnum";

    export default {
        name: "IndexTableCellTripleState",
        props: {
            value: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                controlObject: {
                    success: ActiveIndexTypeEnum.SUCCESS,
                    danger: ActiveIndexTypeEnum.DANGER,
                    info: ActiveIndexTypeEnum.INFO,
                }
            }
        }
    }
</script>

<style scoped>

</style>